module.exports = "/images/_/_/_/_/api.acadevian.com/resources/js/src/assets/images/pages/eCommerce/11.png";